import {   ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material'
import React from 'react'
import { Link, useLocation } from 'react-router-dom';

function NavItem({
    title ,
    icon ,
    href,
    handleClick
}) {
    const { pathname } = useLocation();

  return (
    <>

      <Link to={href} className='flex ' onClick={handleClick} >
          <ListItem key={Math.random()}  >
            <ListItemButton  className={`${pathname === href ? "!bg-[#5a8eee35]" : 1} rounded-3xl`}  >
              <ListItemIcon>
                {icon}
              </ListItemIcon>
              <ListItemText primary={title}  />
            </ListItemButton>
          </ListItem>
      </Link> 
 
    </> 
 )
}

export default NavItem